var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { twMerge } from 'tailwind-merge';
export function MainLayout(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (<div className="flex flex-col px-5 sm:px-10 md:px-20 py-5 gap-5 max-w-large self-center w-full">
			<div className={twMerge('flex flex-col gap-4 w-full', className)} {...props}>
				{children}
			</div>
		</div>);
}
